﻿<script lang="ts">
    import { List, ListGroup, ListItem } from 'framework7-svelte';
    import { createEventDispatcher } from 'svelte';
    import { _ } from "svelte-i18n";
    
    import { indicators } from '../../utils/indicators.js';
    import FloatingButton from '../FloatingButton.svelte';


    export let selectedIndicator: string | null = '';

    const eventDispatcher = createEventDispatcher();

    function selectIndicator(indicator: string | null) {
        selectedIndicator = indicator;
        eventDispatcher('indicatorSelected', indicator);
    }

    function changeShowValues(event) {
        eventDispatcher('showValuesChanged', event.target.checked);
    }
</script>

<FloatingButton label="{$_('pages.project.COLOR_CODING_ROUTES')}" active={!!selectedIndicator} activeIcon="check" inactiveIcon="" popoverWidth="318px">
    <List ul={false}>
        <ListGroup>
            <ListItem groupTitle title="Here routing" />

            <ListItem radio radioIcon="end" title="{$_('shared.DONT_DISPLAY')}" checked={!selectedIndicator} on:change={() => selectIndicator(null)} />

            {#each indicators as ind}
                <ListItem
                    radio
                    radioIcon="end"
                    title={`${ind.displayName} (${ind.unit})`}
                    checked={selectedIndicator === ind.id}
                    on:change={() => selectIndicator(ind.id)}
                />
            {/each}

            <hr class="divider--direction-horizontal" />

            <ListItem checkbox checkboxIcon="end" title="{$_('shared.SHOW_VALUES')}" onChange={changeShowValues} />
        </ListGroup>
    </List>
</FloatingButton>
